
import { defineComponent, reactive, ref, watch } from 'vue'
import ZpForm from '@/Base-UI/form/index'

export default defineComponent({
  name: 'page-search',
  props: {
    formConfig: {
      type: Object,
      required: true
    }
  },
  emits: ['resetBtnClick', 'queryBtnClick'],
  setup(props, { emit }) {
    /* 根据formConfig的field数据为formData动态绑定数据 */
    const formItems = props.formConfig.formItems ?? []
    const formOriginData: any = {}
    for (const item of formItems) {
      formOriginData[item.field] = ''
    }
    let formData = ref(formOriginData)
    /* 重置表单事件 */
    const handleResetClick = () => {
      formData.value = formOriginData
      emit('resetBtnClick')
    }
    /* 搜索框事件 */
    const handleQueryClick = () => {
      emit('queryBtnClick', formData.value)
    }
    return {
      formData,
      handleResetClick,
      handleQueryClick
    }
  },
  components: {
    ZpForm
  }
})
